import { css } from "@emotion/react";
import { FC } from "react";
import { BounceLoader } from "react-spinners";

interface SpinnerT {
  isLoading: boolean;
}

const spinnerStyles = css`
  display: block;
  margin: 0 auto;
  position: absolute;
  top: calc(50% - 75px);
  right: calc(50% - 75px);
  z-index: 20;
`;

const Spinner: FC<SpinnerT> = ({ isLoading }) => {
  return (
    <BounceLoader
      color="#2bfda7"
      loading={isLoading}
      css={spinnerStyles}
      size={150}
    />
  );
};

export default Spinner;
